const firebaseConfig = {
    apiKey: "AIzaSyA3dHU4f7C6TcvQuYSKXIiU97FqQVwwmFE",
    authDomain: "take-over-nail-and-lash.firebaseapp.com",
    databaseURL: "https://take-over-nail-and-lash-default-rtdb.firebaseio.com",
    projectId: "take-over-nail-and-lash",
    storageBucket: "take-over-nail-and-lash.appspot.com",
    messagingSenderId: "467701630122",
    appId: "1:467701630122:web:d0cec4d192b1dbf0643cd3"  
};
firebase.initializeApp(firebaseConfig);
new Vue({
	el: "#app",
	data: {
		client: false,
		is_modal_visible: false,
        was_modal_seen: false,
        tab: "pickup",
		env: {
			gpt: {
				model: {
					options: [
						"gpt-3.5-turbo-16k",
						"gpt-4o",
						"gpt-4o-mini",
						"o1-preview",
						"o1-mini"
					],
					value: "gpt-4o-mini"
				},
				temperature: {
					options: [0, 0.5, 1, 1.5, 2],
					value: 1
				},
				top_p: {
					options: [-1, -0.5, 0, 0.5, 1],
					value: 1
				},
				persona: false,
				query: false,
				response: false,
				response_markdown: false,
				feed: [],
				references: false,
				is_working: false
			}
		},
		stores: [
			{
				id: "takeover",
				name: "Take Over Nail & Lash Supplies",
				address: "1406 6th Ave N, St Cloud, MN 56303",
				image: "https://images.unsplash.com/photo-1727112658582-fdb2e08878d4?q=80&w=5070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
				url: "https://takeoversupplies.com"
			},
			{
				id: "visalia",
				name: "Visalia",
				address: "745 Grant St, Pittsburgh, PA 15219",
				image: "https://images.unsplash.com/photo-1727014589663-38fdc9ea641f?q=80&w=5070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
				url: "https://c3d630-4b.myshopify.com"
			}
		]
	},
	created: function () {
      // document.addEventListener("DOMContentLoaded", () => {
      //   setTimeout(()=>{
      //     document.getElementById("checkout").addEventListener("click", (event) => {
      //       if( !this.was_modal_seen ){
      //         event.preventDefault();
      //         this.fetch_client_location_details();
      //         this.is_modal_visible = true;  
      //       }
      //     });
      //   },100);
      // });
	},
	methods: {
		fetch_client_location_details: function () {
			// let client_cache = localStorage.getItem("store_locator_client");
			fetch(
				"https://ipgeolocation.abstractapi.com/v1/?api_key=0efc902e93234b07b1128d79e8497ee3"
			)
				.then((response) => response.json())
				.then((device_data) => {
					// this.client = ( client_cache ) ? JSON.parse(client_cache) : device_data;
					this.client = device_data;
					this.env.gpt.references = `User Coordinates: ${this.client.latitude},${this.client.longitude}\n
					Store Locations JSON:${JSON.stringify(this.stores)}`;
					this.env.gpt.query = `Review the json of store locations and determine which location is closest to the user's coordinate. Only respond with the "id" of the location in json like this {"id":"5678"}. No prose.`;
					this.stores.forEach( store =>{
						Vue.delete(store, 'is_closest_location');
					});
					this.get_gpt_completion();
					localStorage.setItem("store_locator_client", this.client);
					console.log(this.client);
				})
				.catch((error) => {
					console.log(error);
				});
        },
        transfer_cart: function (store) {
            let that = this;
            // Fetch the cart data from Store 1
            fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                // Process the cart data
                console.log(cart.items); // Cart items
                const cartData = cart.items.map(item => ({
                  id: item.variant_id,  // Variant ID of the product
                  quantity: item.quantity  // Quantity of the product
                }));
        
                // Fetch the variant mapping from Firebase
                fetchVariantMapping().then(mapping => {
                  // Replace variant IDs with mapped values
                  const updatedCartData = cartData.map(item => ({
                    id: mapping[item.id] || item.id,  // Use the mapped ID if it exists, otherwise keep the original ID
                    quantity: item.quantity
                  }));
        
                  // Redirect to Store 1 with updated cart data
                  setTimeout(() => {
                    redirectToStore1(updatedCartData);
                  }, 1000);
                }).catch(error => {
                  console.error('Error fetching variant mapping:', error);
                });
              })
              .catch(error => {
                console.error('Error fetching cart data:', error);
              });
        
            // Function to fetch variant mapping from Firebase
            function fetchVariantMapping() {
              return new Promise((resolve, reject) => {
                let destination_store_id = store.id;
                let source_store_id = false;
        
                // Loop through stores to find source store ID
                that.stores.forEach(store => {
                  if (window.location.href.includes(store.url)) {
                    source_store_id = store.id;
                  }
                });
        
                // Check if source store ID was found
                if (!source_store_id) {
                  reject("Source store ID not found.");
                  return;
                }
        
                // Fetch the variant mapping from Firebase
                firebase.database().ref(`variant_mapping/${source_store_id}_to_${destination_store_id}`).once("value")
                .then(data => {
                  if (data.val()) {
                    resolve(data.val());  // Return the mapping data
                  } else {
                    reject("Cart mapping does not exist.");
                  }
                })
                .catch(error => {
                  reject("Error fetching data from Firebase: " + error);
                });
              });
            }
        
            // Function to redirect to Store 1 with cart data
            function redirectToStore1(cartData) {
              const baseUrl = store.url;
              const queryString = cartData.map(item => `updates[${item.id}]=${item.quantity}`).join('&');
              // Redirect to Store 1's cart URL
              window.location.href = `${baseUrl}?${queryString}`;
            }
        },
		get_gpt_completion: function () {
			let prompt = {
				model: "gpt-4o-mini", //this.env.gpt.model.value,
				messages: [
					{
						role: "user",
						content: `${this.env.gpt.references}\nQuery: ${this.env.gpt.query}\n`
					}
				],
				temperature: 1,
				top_p: 1,
				response_format: { "type": "json_object" }
			};
			let base_url =
				"https://us-central1-yearly-bv3.cloudfunctions.net/gpt_chat_completion";
			let params = {
				p: encodeURIComponent(JSON.stringify(prompt))
			};
			let query_string = Object.keys(params)
				.map((key) => key + "=" + params[key])
				.join("&");
			let url = `${base_url}?${query_string}`;
			console.log("get_gpt_completion request", prompt);
			this.env.gpt.is_working = true;
			fetch(url)
				.then((response) => {
					return response.json();
				})
				.then((data) => {
					console.log("generate_ai_block_prompts response", data);
					let closeset_store_id = JSON.parse(data.response).id; 
					this.stores.forEach( store =>{
						console.log(store)
						if( store.id === closeset_store_id){
							document.startViewTransition(() => {
							  Vue.set(store, 'is_closest_location', true)
							});
							
						} else {
							Vue.set(store, 'is_closest_location', false)
						}
					});
					this.env.gpt.is_working = false;
				})
				.catch((error) => {
					console.error("Error fetching data:", error);
					this.env.gpt.is_working = false;
				});
		},
		
	}
});